var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stacked-flags"},_vm._l((_vm.flags),function(flag){return _c('SdsFlag',{key:flag,staticClass:"stacked-flags__icon",attrs:{"flagName":flag}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }